import React from "react";
import { useSelector } from "react-redux";
//console.log("src/components/Result.js");

export default function Result({ calc, lap, width }) {
  const init = useSelector((state) => state.init);
  const { size, lapp, laph, F0, F1, F2 } = calc;
  let ulap = "";
  if (lap === "h") {
    ulap = init.tv9 + init.tv16 + laph + init.tv3;
  }
  if (lap === "p") {
    ulap = eval("init.tv1" + lapp);
    ulap = init.tv9 + init.tv16 + ulap;
  }
  let amount = Math.ceil((width * 10 - F0 - F1) / F2 + 2);
  const comma = ", ";

  return (
    <article className="calc-item">
      <div>
        {init.tv2}
        {init.tv16}
        {size}
        {init.task2}
        {comma}
        {ulap}
        {comma}
        <span className="amount">
          {init.tv5}
          {init.tv16}
          {amount}
        </span>
      </div>
    </article>
  );
}
